import type { ReactElement } from 'react';
import type { BacklinkDto } from '@gr/core/content/entities/dto';
import { ReferenceTargetKind } from '@gr/core/content/entities/fields';
import { Link, useT } from '../../../../app/di';

/** ENT-UC-7, ENT-RULE-1: кто ссылается на запись (и мешает её удалить). */
export function BacklinkList({ blogId, items }: { blogId: string; items: readonly BacklinkDto[] }): ReactElement {
  const { t } = useT();
  if (items.length === 0) return <p className="u-muted">{t('entities.card.noBacklinks')}</p>;
  return (
    <ul className="u-bullets">
      {items.map((item) => (
        <li key={`${item.kind}-${item.id}-${item.fieldKey}`}>
          {item.kind === ReferenceTargetKind.Post ? (
            <Link to="post" params={{ blogId, postId: item.id }}>
              {t('entities.card.post')}: {item.title}
            </Link>
          ) : (
            <Link to="entity" params={{ blogId, typeId: item.entityTypeId ?? '', entityId: item.id }}>
              {item.title}
            </Link>
          )}{' '}
          <span className="u-muted u-small">· {item.fieldLabel}</span>
        </li>
      ))}
    </ul>
  );
}
